import React, { useCallback, useMemo, useState } from "react";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

function useSearchable<T>(
  items: T[],
  filter: (term: string, item: T) => boolean,
  placeholder?: string
) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems = useMemo(() => {
    if (!searchTerm) return items;
    return items.filter((item) => filter(searchTerm, item));
  }, [items, searchTerm]);

  const SearchBar = (
    <FactsSearchBar
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      placeholder={placeholder}
    />
  );

  return {
    searchTerm,
    items: filteredItems,
    SearchBar: SearchBar,
  };
}

interface FactsSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

const FactsSearchBar: React.FC<FactsSearchBarProps> = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search facts...",
}) => {
  return (
    <div className="relative">
      <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-[var(--fp-ink-3)] focus:border-[var(--fp-ink-3)]"
      />
    </div>
  );
};

export default useSearchable;
